/**
 * Fenice Italy Business API
 * # Fenice Italy Business API  ## General Http Status: HTTP STATUS CODE | DESCRIPTION --- | --- 400 | Business error or general error 401 | Expired token 403 | Access token does not have the required scope 404 | Not found 500 | Internal error  ## Specific Error Codes: Verti has specific errors based on validations, in error field *code*  CODE | DESCRIPTION --- | --- KOIT001 | Plate not valid from SIC/SITA. KOIT002 | Vehicle plate number is not valid. KOIT003 | Login failed. Password is not correct.  ## Annotations:   - In those services that return a list of items, in the case of not found any of them, it will return an empty list.   - For date format, standard ISO 8601. (YYYY-MM-DDThh:mm:ss.sTZD)
 *
 * OpenAPI spec version: 1.2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Attachment } from './attachment';

export interface ContactUsRequest {
  argument?: string;
  /**
   * Text without the code. For 01_acquisto_modifica_101 this will be 01_acquisto_modifica
   */
  argumentID?: string;
  /**
   * Code without the text. For 01_acquisto_modifica_101 this will be 101
   */
  argumentCode?: number;
  name?: string;
  surname?: string;
  email?: string;
  formID?: string;
  formTitle?: string;
  phoneNumber?: string;
  plateNumber?: string;
  policyNumber?: string;
  quoteNumber?: string;
  quoteRenewalNumber?: string;
  quoteOrPolicyNumber?: string;
  claimNumber?: string;
  description?: string;
  complaint?: string;
  /**
   * Text without the code. For 01_acquisto_modifica_101 this will be 01_acquisto_modifica
   */
  complaintID?: string;
  /**
   * Code without the text. For 01_acquisto_modifica_101 this will be 101
   */
  complaintCode?: number;
  subject?: string;
  reference?: string;
  type?: ContactUsRequest.TypeEnum;
  attachments?: Array<Attachment>;
  contactUsEmail?: string;
  contactUsEmailAttachment?: string;
}
export namespace ContactUsRequest {
  export type TypeEnum = 'CONTACT_US' | 'COMPLAINTS';
  export const TypeEnum = {
    CONTACTUS: 'CONTACT_US' as TypeEnum,
    COMPLAINTS: 'COMPLAINTS' as TypeEnum,
  };
}
